import { CLOSE_ALERT, OPEN_ALERT } from "../Action/actionTypes";

const initialState = {
  isOpen: false,
};

const alertReducer = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_ALERT:
      return {
        ...state,
        isOpen: true,
      };
    case CLOSE_ALERT:
      return {
        ...state,
        isOpen: false,
      };
    default:
      return state;
  }
};

export default alertReducer;
